export enum DocumentStatus {
  Draft = 'Draft for review',
  RMReviewed = 'RM reviewed',
  SelfReviewed = 'Self reviewed',
  FinalArchiveReadyVersion = 'Final - Archive ready version',
  SupportingDocument = 'Supporting documentation - no review required',
  DOC_PRESCRENEED_INCLUDES_EDITS = 'Prescreened - includes suggested edits',
  DOC_PRESCREENED_RM_REVIEW = 'Prescreened for RM review - Not for team use',
  DOC_FINAL_VERSION = 'Final version',
  DOC_SELF_REVIEWED = 'Self-reviewed',
  DOC_RMReviewed = 'RM Reviewed',
}

// Parital record as we dont have id for some, if they don't exist we can remove the Partial.
export const DocumentStatusIDMapper: Partial<Record<DocumentStatus, number>> = {
  [DocumentStatus.Draft]: 1,
  [DocumentStatus.DOC_PRESCRENEED_INCLUDES_EDITS]: 2,
  [DocumentStatus.DOC_PRESCREENED_RM_REVIEW]: 3,
  [DocumentStatus.RMReviewed]: 4,
  [DocumentStatus.DOC_FINAL_VERSION]: 5,
  [DocumentStatus.SelfReviewed]: 6,
  [DocumentStatus.SupportingDocument]: 7,
  [DocumentStatus.FinalArchiveReadyVersion]: 8,
};

export enum DocumentArchivalStatus {
  ARCHIVED = 'Archived',
  MOVED = 'Archived',
  PENDING = 'Pending',
}
